import React, { memo } from 'react';

import { WizardButtonProps } from './types';

const Component: React.FC<WizardButtonProps> = memo((props) => {
    const { onClick, children } = props;
    return (
        <button className="btn btn-primary" type="button" onClick={onClick}>
            {children}
        </button>
    );
});
Component.displayName = 'WizardButton';

export const WizardButton: React.FC<WizardButtonProps> = Object.assign(Component, {});
